import api from "./axios";
class ServiceBillFile {
  async deleteFile(id) {
    await api.delete(`bill-file/${id}`)
  }
}

export default new ServiceBillFile()